import {Component} from '@wonderlandengine/api';
import {gameState} from '../state/GameState.js';

export class GameState extends Component {
    static TypeName = 'game-state';
    async start() {
        gameState.currentPlayer.propertyChanged.add((property) => {
            if (property === 'coins') {
                console.log('Coins!', gameState.currentPlayer.coins);
            }
        });
    }
}
